import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, className = '', ...props }) => {
  return (
    <motion.div 
      className={`bg-white rounded-xl overflow-hidden shadow-lg ${className}`}
      whileHover={{ y: -10 }}
      transition={{ duration: 0.3 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Card;